// Global loader manager for axios interceptors
// This allows the interceptor to communicate with the LoaderContext

let loaderCallbacks = {
  increment: null,
  decrement: null,
};

export const setLoaderCallbacks = (increment, decrement) => {
  loaderCallbacks.increment = increment;
  loaderCallbacks.decrement = decrement;
};

export const incrementLoader = () => {
  if (loaderCallbacks.increment) {
    loaderCallbacks.increment();
  }
};

export const decrementLoader = () => {
  if (loaderCallbacks.decrement) {
    loaderCallbacks.decrement();
  }
};
